import React from "react";
import { TenantHeader } from "./TenantHeader";
import { TenantSidebar } from "./TenantSidebar";
import { ScrollToTopLayout } from "@/components/Layouts/ScrollToTopLayout";

interface TenantLayoutProps {
  children: React.ReactNode;
  showSidebar?: boolean; // Deprecated: Sidebar now handles its own visibility
}

/**
 * Tenant Layout - Main layout for tenant users
 * Used for unit management, detailed pages, dashboard, and fleet management
 * 
 * Note: Sidebar is always rendered and handles its own visibility logic:
 * - Mobile: Always shows in drawer (all pages)
 * - Desktop: Only shows on unit pages
 */
export const TenantLayout: React.FC<TenantLayoutProps> = ({ children }) => {
  return (
    <ScrollToTopLayout>
      <div className="h-screen bg-ds-dark flex flex-col">
        <TenantHeader />
        <div className="flex flex-1 overflow-hidden pt-[58px]">
          {/* Sidebar always rendered - handles its own visibility logic */}
          <TenantSidebar />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-ds-dark mobile-scroll">
            {children}
          </main>
        </div>
      </div>
    </ScrollToTopLayout>
  );
};

